import ProductPrice from "./ProductPrice";
import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";
import "../catalog.css";
export default function PromotedProducts() {
  const { data } = useQuery(["featured-products"], async () => {
    const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/product/featured`);
    return response.data.data;
  }, { retry: false });
  if (!Array.isArray(data) || !data.length) return null;
  return <section className="hs-wrap hs-section" aria-labelledby="featured-products-title">
    <div className="hs-section-heading"><div><p className="hs-eyebrow">SELECTED BY TECHNOGENIOUS</p><h2 id="featured-products-title">Featured products</h2></div><Link to="/products">Shop all products →</Link></div>
    <div className="catalog-grid">{data.map(p => <article className="catalog-card" key={p._id}>
      <Link className="catalog-image" to={`/product/${p._id}`}><img src={p.image} alt={p.name} loading="lazy" onError={e=>{e.currentTarget.onerror=null;e.currentTarget.src="/catalog/placeholder.svg";}} /></Link>
      <div className="catalog-card-body"><span className="promotion-badge">Featured</span><h3><Link to={`/product/${p._id}`}>{p.name}</Link></h3><div className="catalog-card-bottom"><strong>{p.tags?.includes("catalog-review") || p.option?.length || !Number.isFinite(p.price) || p.price <= 0 ? "Request a quote" : <ProductPrice price={p.price} compareAtPrice={p.compareAtPrice}/>}</strong><Link to={`/product/${p._id}`}>View product →</Link></div></div>
    </article>)}</div>
  </section>;
}
